import { render } from "./CalendarPage.vue?vue&type=template&id=5107f0c3&ts=true"
import script from "./CalendarPage.vue?vue&type=script&lang=ts"
export * from "./CalendarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__